<template>
    <v-row>
        <v-col cols="4"></v-col>
        <v-col cols="4" class="text-center">
            <div class="text-h4">TV List</div>
            <v-divider class="border-opacity-25"></v-divider>
        </v-col>
    </v-row>
    <v-row>
        <!--LIST OF TVS-->
        <v-col cols="4" />
        <v-col cols="4" class="text-center">
            <v-card elevation="11" height="500px" class="scroll">
                <v-list>
                    <Link
                        v-for="(tv, index) in tvs"
                        :key="index"
                        :value="tv.path"
                        :href="route(tv.path)"
                    >
                        <v-list-item class="text-wrap list-item">
                            {{ tv.name }}
                            <v-divider />
                        </v-list-item>
                    </Link>
                </v-list>
            </v-card>
        </v-col>
        <v-col cols="4" />
    </v-row>

    <v-row>
        <v-col cols="4"></v-col>
        <v-col cols="4" class="text-center">
            <div class="text-h5">More Applications</div>
            <v-divider class="border-opacity-25"></v-divider>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="4" />
        <v-col cols="4" class="text-center">
            <v-card elevation="11" height="200px" class="scroll">
                <v-list>
                    <a
                        v-for="(app, index) in applications"
                        :key="index"
                        :value="app.path"
                        :href="app.path"
                    >
                        <v-list-item class="text-wrap list-item">
                            {{ app.name }}
                            <v-divider />
                        </v-list-item>
                    </a>
                </v-list>
            </v-card>
        </v-col>
        <v-col cols="4" />
    </v-row>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";

export default {
    components: {
        Link,
    },
    data() {
        return {
            tvs: [
                {
                    path: "ASM20",
                    name: "Assembly 20",
                },
                {
                    path: "ASM70",
                    name: "Assembly 70",
                },
                {
                    path: "ASM75",
                    name: "Assembly 75",
                },
                // {
                //     path: "ASM85",
                //     name: "Assembly 85",
                // },
                {
                    path: "CNC20",
                    name: "CNC 20",
                },
                {
                    path: "CNC70",
                    name: "CNC 70",
                },
                {
                    path: "CNC75",
                    name: "CNC 75",
                },
                // {
                //     path: "CNC85",
                //     name: "CNC 85",
                // },
                {
                    path: "WHSE20",
                    name: "Logistics 20",
                },
                {
                    path: "WHSE70",
                    name: "Logistics 70",
                },
                {
                    path: "WHSE75",
                    name: "Logistics 75",
                },
                {
                    path: "WHSE85",
                    name: "Logistics 85",
                },
                {
                    path: "SIL20",
                    name: "Silkscreen 20",
                },
                {
                    path: "SIL70",
                    name: "Silkscreen 70",
                },
                {
                    path: "SIL75",
                    name: "Silkscreen 75",
                },
                // {
                //     path: "SIL85",
                //     name: "Silkscreen 85",
                // },
                {
                    path: "VACF20",
                    name: "Thermoforming 20",
                },
                {
                    path: "VACF70",
                    name: "Thermoforming 70",
                },
                {
                    path: "VACF75",
                    name: "Thermoforming 75",
                },
                // {
                //     path: "VACF85",
                //     name: "Thermoforming 85",
                // },
            ],
            applications: [
                {
                    path: "https://dbrconnect.d3llc.org/",
                    name: "DBR Connect",
                },
                {
                    path: "https://dmxconnect.d3llc.org/",
                    name: "DMX Connect",
                },
                {
                    path: "https://dpam.d3llc.org/",
                    name: "DPAM",
                },
                {
                    path: "https://fieldflexv2.d3llc.org/",
                    name: "Fieldflex",
                },
            ],
        };
    },
};
</script>

<style lang="css" scoped>
.scroll {
    overflow-y: scroll;
}

.list-item:hover {
    background-color: #eceff1;
}
</style>
